<mat-card>
  <mat-card-content fxLayout="column">
    <div fxFlexAlign="end" style="padding-top: 5px">
      <button color="accent" mat-raised-button matTooltip="Créer une nouvelle catégorie"
              data-cy="btn-cat-list-new-cat" (click)="addCategorie()">
        <mat-icon data-cy="icon-cat-list-add">add</mat-icon>
        NOUVELLE CATÉGORIE
      </button>
    </div>
    <app-data-table
      [actions]="actions"
      [columns]="columns"
      [extraParams]="extraParams"
      [dataSource]="dsItems"
      [filterDisplay]="true"
      [minFilter]="2"
      [flexAction]="5"
      [flexColumn]="90"
      [fontSizeCell]="'0.9em'"
      [pageSize]="10"
      [pageSizesList]="[5,10,25]"
      [placeHolderFilter]="'Rechercher des categories'"
      [refreshButton]="false"
      [refreshIcone]="false"
      [showFirstLastButtons]="true"
      [showLoader]="true"
      [loaderMask]="false"
    ></app-data-table>
  </mat-card-content>
</mat-card>
